<template>
  <div>
    <units-select v-if="showUnits"></units-select>
    <div class="page">
      <div v-if="showBreadcrumbs" class="page__breadcrumb">
        <div
          v-for="(breadcrumb, i) in _breadcrumbs"
          class="page__breadcrumb__item"
          :key="i"
        >
          <span
            :class="`${
              i === _breadcrumbs.length - 1 ? '--breadcrumb-current-page' : ''
            }
                                 ${breadcrumb.path ? '--breadcrumb-link' : ''}`"
            @click="breadcrumbLink(breadcrumb.path)"
          >
            {{ breadcrumb.text }}
          </span>
          <i class="bexsicon-right" v-if="i < _breadcrumbs.length - 1" />
        </div>
      </div>
      <div class="page__header" :style="{ color: themeColor }">
        <div class="page__header__primary__item">
          <div class="page__icon">
            <i :class="`bexsicon-${icon}`" />
          </div>
          <div class="page__title">
            {{ title }}
          </div>
        </div>
        <slot name="header"></slot>
      </div>
      <screen-loading v-if="loading"></screen-loading>
      <div v-else>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import UnitsSelect from '@/components/unitsSelect/UnitsSelect';
import ScreenLoading from '@/components/loaders/ScreenLoading';
export default {
  name: 'module-page',
  components: {
    UnitsSelect,
    ScreenLoading,
  },
  computed: {
    _breadcrumbs: function () {
      return [
        ...this.breadcrumbs,
        ...(this.customBreadcrumbs || [{ text: this.title }]),
      ];
    },
  },
  props: {
    showBreadcrumbs: {
      type: Boolean,
      default: true,
    },
    showUnits: {
      type: Boolean,
      default: true,
    },
    customBreadcrumbs: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    themeColor: {
      type: String,
      required: true,
    },
    loading: Boolean,
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Página Inicial',
          path: '/',
        },
      ],
    };
  },
  methods: {
    breadcrumbLink(path) {
      if (path) this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.page {
  width: 100%;
  margin: 0 auto;
  max-width: 1366px;

  @include breakpoint(mobile) {
    width: 95%;
    min-width: initial;
  }

  &__breadcrumb {
    padding: 0.75em 0.5em;
    display: inline-flex;
    width: 100%;
    border-bottom: 1px solid #ececec;
    @include breakpoint(mobile) {
      display: none;
    }

    .--breadcrumb-current-page {
      color: var(--light-dark-color);
      font-weight: 700;
    }
    .--breadcrumb-link {
      cursor: pointer;
      &:hover {
        border-bottom: 1px solid #979696;
      }
    }

    &__item {
      font-size: 0.75em;
      color: #979696;

      i {
        font-size: 0.75em;
        padding: 0.5em;
      }
    }
  }

  &__header {
    width: 100%;
    display: flex;
    padding: 0.5em;
    justify-content: space-between;
    &__primary__item {
      display: flex;
      width: auto;
    }
    &__second__item {
      flex: 0.8;
      margin-top: 5px;
    }
    @include breakpoint(mobile) {
      flex-direction: column;
    }
  }

  &__title {
    font-size: 24px;
    text-align: left;
    padding: 7.5px 10px;
    flex: 0.95;
  }

  &__icon {
    font-size: 2.85em;
    flex: 0.05;
    text-align: left;
    padding: 0 0.1em;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/layout/Page.vue